import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { RequireAuth } from '@/auth/RequireAuth'
import { RequireRole } from '@/auth/RequireRole'
import { roleHome } from '@/auth/routes'
import { FullScreenSpinner } from '@/components/ui/FullScreenSpinner'
import { RoleLayout } from '@/components/layout/RoleLayout'
import { AdminLayout } from '@/features/admin/AdminLayout'
import { AdminOverviewPage } from '@/features/admin/AdminOverviewPage'
import { ProjectsPage } from '@/features/admin/projects/ProjectsPage'
import { SettingsPage } from '@/features/admin/settings/SettingsPage'
import { UsersPage } from '@/features/admin/users/UsersPage'
import { ProjectDetailPage } from '@/features/projects/ProjectDetailPage'
import { LoginPage } from '@/features/auth/LoginPage'
import { ClientDashboard } from '@/features/dashboards/ClientDashboard'
import { SupplierDashboard } from '@/features/dashboards/SupplierDashboard'

/** `/` routes signed-in users to their home and everyone else to sign-in. */
function RootRoute() {
  const { status, role } = useAuth()
  if (status === 'loading') {
    return <FullScreenSpinner />
  }
  if (status === 'authenticated') {
    return <Navigate to={roleHome(role)} replace />
  }
  return <Navigate to="/login" replace />
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<RequireRole allow="admin" />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverviewPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/:id" element={<ProjectDetailPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
        <Route element={<RequireRole allow="supplier" />}>
          <Route path="/supplier" element={<RoleLayout />}>
            <Route index element={<SupplierDashboard />} />
            <Route path="projects/:id" element={<ProjectDetailPage />} />
          </Route>
        </Route>
        <Route element={<RequireRole allow="client" />}>
          <Route path="/client" element={<RoleLayout />}>
            <Route index element={<ClientDashboard />} />
            <Route path="projects/:id" element={<ProjectDetailPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="/" element={<RootRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
